export const ASSETS = {
  heroPortrait: "https://customer-assets.emergentagent.com/job_45ba080c-71c0-467e-9212-fb83ccf7d277/artifacts/4u6bn22c_3D07E095-B5C2-4335-BADB-C0F4378CBC40.png",
  about: "https://customer-assets.emergentagent.com/job_elite-leads-3/artifacts/3xutn1wz_F5717EB5-1B0D-4A1F-A1CB-23D101548C17.png",
  coachTraining: "https://static.prod-images.emergentagent.com/jobs/45ba080c-71c0-467e-9212-fb83ccf7d277/images/2a6905435adf747105c77f1429ab55cb53083a347b65e23257f6993b68dc69c2.png",
  textureFocus: "https://images.unsplash.com/photo-1504507926084-34cf0b939964?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
};

// ACTO 2 — EL DOLOR (abrir la herida). Líneas cortas que van subiendo de intensidad.
export const CONVERSATION = [
  "Empiezas todos los lunes.",
  "Y todos los lunes acabas abandonando.",
  "“Esta vez será diferente”, te prometes. No lo es.",
  "Te escondes detrás de la ropa. Evitas el espejo.",
  "Sabes perfectamente lo que deberías hacer. Pero nunca lo mantienes.",
  "Llevas años esperando el momento perfecto.",
  "Y cada intento fallido te hace confiar un poco menos en ti.",
];

// ACTO — Prueba: cada cambio físico validado con un testimonio emocional (se alternan).
export const PROOF = [
  {
    img: "https://customer-assets.emergentagent.com/job_elite-leads-3/artifacts/574vsq7n_6EE50202-DC5F-41D0-92BC-EC88F2AD2932.jpeg",
    recovered: "Volvió a reconocerse",
    quote: "Dejé de esconderme detrás de la ropa. Volví a mirarme al espejo sin apartar la vista.",
    name: "Cliente · Elite Coaching",
  },
  {
    img: "https://customer-assets.emergentagent.com/job_elite-leads-3/artifacts/u18ztsb6_EAB78983-6A5F-4DF2-920C-63A87DB34883.jpeg",
    recovered: "Dejó de empezar todos los lunes",
    quote: "Llevaba años empezando y abandonando cada lunes. Hoy ya no dependo de la motivación: cumplo lo que me digo.",
    name: "Cliente · Elite Coaching",
  },
  {
    img: "https://customer-assets.emergentagent.com/job_elite-leads-3/artifacts/3okdkyvj_IMG_3895.jpeg",
    recovered: "Recuperó la confianza",
    quote: "No fue solo el cuerpo. Por primera vez en años volví a sentirme orgullosa de quien soy.",
    name: "Clienta · Elite Coaching",
  },
  {
    img: "https://customer-assets.emergentagent.com/job_elite-leads-3/artifacts/vdgcdqma_749BE7F9-1DDE-4696-B34C-E74006C1BC40.jpeg",
    recovered: "No volvió a abandonar",
    quote: "Por primera vez no abandoné a mitad de camino. Y eso lo cambió todo: ahora me siento capaz.",
    name: "Clienta · Elite Coaching",
  },
  {
    img: "https://customer-assets.emergentagent.com/job_elite-leads-3/artifacts/xdpdnein_Untitled%20design.jpeg",
    recovered: "Dejó de empezar de cero",
    quote: "Dejé de empezar de cero una y otra vez. Ahora simplemente soy constante, sin pelear conmigo misma.",
    name: "Clienta · Elite Coaching",
  },
];

// ACTO 6 — el sistema (chapters). Copy emocional, con personalidad.
export const METHOD = [
  { n: "01", t: "Por qué nunca duró", d: "Antes de cambiar tu cuerpo, entendemos por qué nunca has conseguido mantener un cambio." },
  { n: "02", t: "Tu vida, tu sistema", d: "Un sistema construido alrededor de tu realidad. No de una dieta. No de un entrenamiento. De ti." },
  { n: "03", t: "Dejar de abandonar", d: "Acompañamiento y responsabilidad de verdad. No buscamos perfección: buscamos que dejes de abandonar." },
  { n: "04", t: "Una nueva identidad", d: "El objetivo no es el físico. Es convertirte en otra persona. El físico será la consecuencia." },
];

export const FINAL_BENEFITS = [
  "Valoración gratuita",
  "Sin compromiso",
  "100% personalizado",
  "Comunidad Elite Coaching",
];

export const GOAL_OPTIONS = [
  { value: "perder_grasa", label: "Perder grasa" },
  { value: "ganar_musculo", label: "Ganar músculo" },
  { value: "recomposicion", label: "Recomposición corporal" },
  { value: "mejorar_habitos", label: "Mejorar hábitos" },
];

export const STATUS_LABELS = {
  nuevo: "Nuevo",
  contactado: "Contactado",
  llamada_realizada: "Llamada realizada",
  cliente: "Cliente",
  no_interesado: "No interesado",
};

export const STATUS_COLORS = {
  nuevo: "#D4AF37",
  contactado: "#60A5FA",
  llamada_realizada: "#A78BFA",
  cliente: "#34D399",
  no_interesado: "#9CA3AF",
};
